import { faObjectGroup } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@farmshare/ui-components';

import { useMergeWizardModal } from '../hooks/use-merge-wizard-modal';
import { type CustomerSummary } from './merge-wizard-types';

export interface MergeRowActionProps {
  vendorId: string | undefined;
  customer: CustomerSummary;
  onMergeCompleted: () => void;
}

export function MergeRowAction({
  vendorId,
  customer,
  onMergeCompleted,
}: MergeRowActionProps) {
  const openMergeWizard = useMergeWizardModal();

  return (
    <Button
      size="sm"
      className="ms-1"
      content="Merge…"
      icon={faObjectGroup}
      onClick={() =>
        openMergeWizard({
          vendorId,
          initiatingCustomer: customer,
          onCompleted: onMergeCompleted,
        })
      }
    />
  );
}
